import { render, staticRenderFns } from "./checkManagement.vue?vue&type=template&id=a65f2d90"
import script from "./checkManagement.vue?vue&type=script&lang=js"
export * from "./checkManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports